var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDomainVerification(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_28_686",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 101
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.258789,
    y: 0.259766,
    width: 99.7412,
    height: 99.7412,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_28_686)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8826 83.3763C14.5968 83.3763 12.6401 82.5624 11.0124 80.9347C9.38466 79.307 8.5708 77.3503 8.5708 75.0645V25.1939C8.5708 22.9082 9.38466 20.9514 11.0124 19.3237C12.6401 17.696 14.5968 16.8821 16.8826 16.8821H83.3767C85.6624 16.8821 87.6192 17.696 89.2469 19.3237C90.8746 20.9514 91.6885 22.9082 91.6885 25.1939V75.0645C91.6885 77.3503 90.8746 79.307 89.2469 80.9347C87.6192 82.5624 85.6624 83.3763 83.3767 83.3763H16.8826ZM16.8826 33.5057H83.3767V25.1939H16.8826V33.5057ZM45.766 69.0385L69.2467 45.5577L63.2207 39.5317L45.766 56.9864L37.0386 48.2591L31.0126 54.2851L45.766 69.0385Z",
    fill: "#65B777"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomainVerification);
export default __webpack_public_path__ + "static/media/domain_verification.3bf53b1e03dbc323d9f27a48f405a215.svg";
export { ForwardRef as ReactComponent };